<template>
  <GBox class="bank-information">
    <Alert
      class="g-mb-16"
      :texts="warningTexts"
      v-if="editable"
    />
    <form
      action="#"
      novalidate
      @submit.prevent="onSubmit"
    >
      <GBox class="form-input-container">
        <GBox class="input-container">
          <GText
            variant="subtitle-03"
            color="mid-grey-500"
            class="g-mb-4"
          >
            {{ $t('account.labels.iban') }}
          </GText>
          <input
            class="form-control"
            :class="{'is-invalid' : !isValid}"
            :disabled="isDisabled"
            type="text"
            name="iban"
            v-model="bankInformation.iban"
            v-mask="'TR99 9999 9999 9999 9999 9999 99'"
            :placeholder="ibanPlaceholder"
          >
          <GAlert
            v-if="bankInformation.distrained && editable"
            class="g-mt-8"
            variant="error"
            :border="true"
          >
            {{ $t('account.distrainedInfoText') }}
          </GAlert>
        </GBox>
        <template v-if="editable">
          <GTooltip
            v-if="!bankInformation.canUpdate"
            class="tooltip-wrapper"
            :text="$t('account.updateIbanDisabledTooltipText')"
            placement="right"
          >
            <template #tooltip-trigger>
              <GButton :disabled="isDisabled">
                {{ $t('account.update') }}
              </GButton>
            </template>
          </GTooltip>
          <GButton
            v-else
            :disabled="isDisabled"
          >
            {{ $t('account.update') }}
          </GButton>
        </template>
      </GBox>
    </form>

    <ConfirmationModal
      :show="showConfirmationModal"
      text="İlettiğim bilginin doğru olduğunu ve sorumluluğun tarafıma ait olduğunu taahhüt ederim."
      @close="onConfirmCancel"
      @submit="updateIban"
    />
  </GBox>
</template>

<script>

import account from '@/services/account';
import Alert from '@/components/Shared/Alert';
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import GButton from '@trendyol-js/grace/core/GButton';
import GTooltip from '@trendyol-js/grace/core/GTooltip';
import GAlert from '@trendyol-js/grace/core/GAlert';
import ConfirmationModal from '@/components/Info/Modals/ConfirmationModal';

export default {
  name: 'BankInformation',
  components: {
    Alert,
    GButton,
    GBox,
    GTooltip,
    GText,
    GAlert,
    ConfirmationModal,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showConfirmationModal: false,
      bankInformation: {
        iban: '',
        distrained: false,
        canUpdate: false,
      },
      currentIban: '',
      warningTexts: [
        'Banka hesap isminiz, Trendyol cari isminiz ile aynı olmalıdır.',
        'IBAN numarasının VKN ya da TCKN ile uyumlu olması gerekmektedir.',
        'Güncellenen IBAN’a mevcut hakedişlerin ödemesi, güncelleme işlemini takip eden ilk ödeme gününde yapılacaktır.',
      ],
    };
  },
  created () {
    this.getBankInformation();
  },
  computed: {
    ibanPlaceholder () {
      if (this.isDisabled) {
        return '---';
      }
      return 'TR99 9999 9999 9999 9999 9999 99';
    },
    isDisabled () {
      return !this.bankInformation.canUpdate || this.bankInformation.distrained || !this.editable;
    },
    isValid () {
      return this.iban.length === 26;
    },
    iban () {
      return (this.bankInformation.iban || '')
        .replace(/ /g, '')
        .replace(/_/g, '');
    },
  },
  methods: {
    async getBankInformation () {
      this.bankInformation = await account.getBankInformation();
      this.currentIban = this.bankInformation.iban;
    },
    async updateIban () {
      this.onConfirmCancel();
      await account.updateIban({ iban: this.iban, currentIban: this.currentIban });
      this.currentIban = this.iban;
      this.$toast.success('Talebiniz alınmıştır. Kısa süre içerisinde IBAN güncelleme işleminiz gerçekleştirilecektir ve tarafınıza mail ile bilgi verilecektir.');
    },
    onSubmit () {
      this.showConfirmationModal = this.isValid;
    },
    onConfirmCancel () {
      this.showConfirmationModal = false;
    },
  },
};
</script>
<style scoped lang="scss">
  .bank-information {

    .form-input-container {
      max-width: 600px;

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      ::v-deep .mp-label {
        font-size: 14px;

        .icon {
          margin-right: 0;
        }
      }

      .input-container {
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;

        .form-input {
          width: 100%;
        }
      }
    }

    .tooltip-wrapper::v-deep .text{
      width: 300px;
      max-width: 300px;
    }

    @media only screen and (max-width: 992px) {
      width: 100%;
    }
  }
</style>
